import dayjs, { Dayjs } from "dayjs";

export const toYearMonthDay01 = (d: Dayjs) => d.format("YYYY-MM-01");

export const esc = (s: string) =>
    s.replace(/\\/g, "\\\\").replace(/"/g, '\\"').replace(/\r?\n/g, " ").trim();

export const listToRows = (list: any[]) =>
    (list ?? [])
        .map(it => {
            const m = dayjs(it.yearAndMonth);
            return {
                key: m.format("YYYY-MM"),
                id: it.kidsWorldVideoId,
                monthLabel: m.locale("en").format("YYYY-MMM"),
                yearAndMonthRaw: it.yearAndMonth,
                v1: it.vimeoId1 ? String(it.vimeoId1) : undefined,
                v2: it.vimeoId2 ? String(it.vimeoId2) : undefined,
                v3: it.vimeoId3 ? String(it.vimeoId3) : undefined,
                v4: it.vimeoId4 ? String(it.vimeoId4) : undefined,
                v5: it.vimeoId5 ? String(it.vimeoId5) : undefined,
                title1: it.title1,
                title2: it.title2,
                title3: it.title3,
                title4: it.title4,
                title5: it.title5
            };
        })
        .sort(
            (a, b) =>
                Number(dayjs(b.yearAndMonthRaw).format("YYYYMM")) -
                Number(dayjs(a.yearAndMonthRaw).format("YYYYMM"))
        );
